import type {CSSProperties} from 'react';

const BADGE_RING = 'var(--splash-bg, #f4f6f8)';

export const LIGHT_INK_VARS = {
  '--sp-ink': 'var(--chekin-blue-900)',
  '--sp-ink-soft': 'var(--chekin-text-secondary)',
  '--sp-ink-faint': 'var(--chekin-text-tertiary)',
  '--sp-hairline': 'var(--chekin-border-default)',
  '--sp-badge-ring': BADGE_RING,
} as CSSProperties;

export const DARK_INK_VARS = {
  '--sp-ink': '#ffffff',
  '--sp-ink-soft': 'rgba(255, 255, 255, 0.76)',
  '--sp-ink-faint': 'rgba(255, 255, 255, 0.52)',
  '--sp-hairline': 'rgba(255, 255, 255, 0.18)',
  '--sp-badge-ring': BADGE_RING,
} as CSSProperties;
